import { useField, useFormikContext } from 'formik'
import { BrandStylePreview } from 'screens/BrandKits/components/BrandStandard/BrandStyleCard/BrandStylePreview'
import { useBrandVisualKits } from 'hooks/queries/workspaces/useBrandVisualKits'
import { BrandStyle as BrandStyle36 } from 'blaze-ui/icons/32'
import { BrandVisualKit } from 'types'
import { DesignWizardField } from '../DesignWizardField'
import { useModals } from 'almanac-ui/Modal'
import { BrandKitsModal } from './BrandKitsModal'
import { PressableBrandAICard } from 'screens/BrandKits/components/BrandAICard/BrandAICard'
import { BrandWizardIntegrationSelection } from 'components/BrandWizardIntegrationSelection/BrandWizardIntegrationSelection'
import { Loading } from '../Loading'
import Styles from '../DesignWizardField.module.scss'

export const BrandKitField = () => {
  const { openModal, closeStack } = useModals()
  const [brandVisualKitIdField, ,] = useField('brand_visual_kit_id')
  const { setValues } = useFormikContext<{ [key: string]: any }>()

  const setBrandVisualKitId = (kitId: number | null | undefined) => {
    setValues((values) => ({
      ...values,
      brand_visual_kit_id: kitId,
    }))
  }

  const brandVisualKitsQuery = useBrandVisualKits({
    staleTime: 10 * 60 * 1000, // 10 minutes
  })
  const brandVisualKits = brandVisualKitsQuery.data?.brand_visual_kits
  const isLoading = brandVisualKitsQuery.isLoading
  const selectedKit = brandVisualKits?.find((kit: BrandVisualKit) => kit.id === brandVisualKitIdField.value)

  const openCreateModal = () => {
    openModal(
      BrandWizardIntegrationSelection,
      {
        onConfirm: (kit) => {
          setBrandVisualKitId(kit.id)
          closeStack()
        },
      },
      { newStack: true },
    )
  }

  const handlePress = () => {
    if (!brandVisualKits?.length) return

    openModal(
      BrandKitsModal,
      {
        initialKit: selectedKit,
        brandVisualKits,
        onSelect: (kitId) => setBrandVisualKitId(kitId),
      },
      { newStack: true },
    )
  }

  if (isLoading) return <Loading />

  if (!selectedKit || !brandVisualKits)
    return (
      <DesignWizardField
        title="Brand Style"
        isEmpty
        emptyIcon={<BrandStyle36 size={40} />}
        emptyLabel={brandVisualKits?.length === 0 ? 'Create your first Brand Style' : 'Select a Brand Style'}
        onPress={brandVisualKits?.length === 0 ? openCreateModal : handlePress}
      />
    )

  return (
    <DesignWizardField
      title="Brand Style"
      className={Styles.brandKit}
      onButtonPress={handlePress}
      buttonLabel="Change Brand Style"
    >
      <PressableBrandAICard
        preview={() => <BrandStylePreview kit={selectedKit} />}
        title={selectedKit.name}
        lineClamp={1}
        onPress={handlePress}
      />
    </DesignWizardField>
  )
}
